import React, { useState } from "react";
import "./Expenses.css";
import CustomSwitch from "../../Components/CustomSwitch/CustomSwitch";
import Checkbox from "@mui/material/Checkbox";

const initialExpensesData = [
  {
    id: 1,
    question:
      "Any amounts paid for healthcare and to doctors, dentists, hospitals",
    enabled: false,
    explanation: "",
  },
  {
    id: 2,
    question:
      "Did you make any charitable contributions? If yes, please give details.",
    enabled: false,
    explanation: "",
  },
  {
    id: 3,
    question:
      "Do you have a Home Mortgage Interest in US or India? If yes, please give details.",
    enabled: false,
    explanation: "",
  },
  {
    id: 4,
    question: "Any casualty or theft losses? If yes, please give details",
    enabled: false,
    explanation: "",
  },
  {
    id: 5,
    question: "Have you paid alimony in 2020? If yes please specify the amount",
    enabled: false,
    explanation: "",
  },
  {
    id: 6,
    question:
      "Did you itemize your returns last year? if yes please provide state refund",
    enabled: false,
    explanation: "",
  },
  {
    id: 7,
    question:
      "Did you pay any Sales and Excise taxes on vehicle bought in 2020. If yes please upload bills",
    enabled: false,
    explanation: "",
  },
  {
    id: 8,
    question:
      "If you are resident of MA State, NJ State, CA State IN State, WI State? Provide Per month rent you are paying",
    enabled: false,
    explanation: "",
  },
  {
    id: 9,
    question:
      "If you are resident of MA State? Are you and your family covered with MA health insurance? If yes, mention the no. of months covered..",
    enabled: false,
    explanation: "",
  },
  {
    id: 10,
    question:
      "If you are resident of OH & PA for 2020? If yes please provide your Home and Work address",
    enabled: false,
    explanation: "",
  },
];
const initialContributionsData = [
  {
    id: 1,
    question:
      "Do you make any additional contributions to H.S.A/ Apart from you we?",
    enabled: false,
    explanation: "",
  },
  {
    id: 2,
    question:
      "Do you make any additional contributions to I.R.A/401k plan Apart from you we?",
    enabled: false,
    explanation: "",
  },
  {
    id: 3,
    question: "Do you have student loan? If yes, please upload document 1098E",
    enabled: false,
    explanation: "",
  },
  {
    id: 4,
    question:
      "Did you pay any tuition fee for self, spouse or dependents? If yes, please upload document 1098T.",
    enabled: false,
    explanation: "",
  },
  {
    id: 5,
    question: "Is your health insurance covered from employer or market place?",
    enabled: false,
    explanation: "",
  },
  {
    id: 6,
    question:
      "Form 1095-A if you enrolled in an insurance plan through the Marketplace",
    enabled: false,
    explanation: "",
  },
  {
    id: 7,
    question:
      "Did you purchase any energy saving product in USA? If yes please specify it.",
    enabled: false,
    explanation: "",
  },
  {
    id: 8,
    question: "Have you purchased any Hybrid motor Vehicle in the TY 2020?",
    enabled: false,
    explanation: "",
  },
];
const ClientDashboardExpenses = () => {
  const [expensesData, setExpensesData] = useState(initialExpensesData);
  const [contributionsData, setContributionsData] = useState(
    initialContributionsData
  );
  return (
    <div className="clientdashboard__expenses_section">
      <div className="clientdashboard__expenses_wrapper">
        <div className="clientdashboard__expenses_innersection">
          <div className="clientdashboard__expenses_inrsecheader">
            <div> Expenses</div>
          </div>
          <div className="clientdashboard__expenses_inrsecbody">
            {expensesData.map((item, index) => (
              <>
                <div className="clientdashboard__expenses_isbitem">
                  <div className="clientdashboard__expenses_isbileft">
                    {item.question}
                  </div>
                  <div className="clientdashboard__expenses_isbiright">
                    <span>{item.enabled ? "YES" : "NO"}</span>{" "}
                    <CustomSwitch
                      onSwitch={(enabled) => {
                        setExpensesData(
                          expensesData.map((itm, idx) => {
                            if (index === idx) {
                              return { ...itm, enabled };
                            } else {
                              return itm;
                            }
                          })
                        );
                      }}
                    />
                  </div>
                </div>
                {item.enabled && (
                  <textarea
                    className="clientdashboard__expenses_isbexplain"
                    placeholder="Please Explain"
                  ></textarea>
                )}
              </>
            ))}
          </div>
        </div>
        <div
          className="clientdashboard__depndtinfo_checkboxitm2"
          style={{ border: "none" }}
        >
          <div className="clientdashboard__depndtinfo_cbicbox">
            {" "}
            <Checkbox
              defaultChecked
              sx={{
                "&.Mui-checked": {
                  color: "rgba(29, 66, 102, 1)",
                },
              }}
            />
          </div>
          <div className="clientdashboard__depndtinfo_cbirttxt">
            I declare that the information in this application is true and
            correct
          </div>
        </div>
      </div>
      <div className="clientdashboard__expenses_wrapper">
        <div className="clientdashboard__expenses_innersection">
          <div className="clientdashboard__expenses_inrsecheader">
            <div> Contributions</div>
          </div>
          <div className="clientdashboard__expenses_inrsecbody">
            {contributionsData.map((item, index) => (
              <>
                <div className="clientdashboard__expenses_isbitem">
                  <div className="clientdashboard__expenses_isbileft">
                    {item.question}
                  </div>
                  <div className="clientdashboard__expenses_isbiright">
                    <span>{item.enabled ? "YES" : "NO"}</span>{" "}
                    <CustomSwitch
                      onSwitch={(enabled) => {
                        setContributionsData(
                          contributionsData.map((itm, idx) => {
                            if (index === idx) {
                              return { ...itm, enabled };
                            } else {
                              return itm;
                            }
                          })
                        );
                      }}
                    />
                  </div>
                </div>
                {item.enabled && (
                  <textarea
                    className="clientdashboard__expenses_isbexplain"
                    placeholder="Please Explain"
                  ></textarea>
                )}
              </>
            ))}
          </div>
        </div>
        <div
          className="clientdashboard__depndtinfo_checkboxitm2"
          style={{ border: "none" }}
        >
          <div className="clientdashboard__depndtinfo_cbicbox">
            {" "}
            <Checkbox
              defaultChecked
              sx={{
                "&.Mui-checked": {
                  color: "rgba(29, 66, 102, 1)",
                },
              }}
            />
          </div>
          <div className="clientdashboard__depndtinfo_cbirttxt">
            I declare that the information in this application is true and
            correct
          </div>
        </div>
      </div>

      <br />
      <div className="clientdashboard__expenses_wrapper">
        <div className="clientdashboard__expenses_bottombtns">
          <button className="clientdashboard__expenses_bottombtn1">Save</button>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboardExpenses;
